<div class="toggle-cta" [class.active]="value" (click)="toggle.emit(!value)">
  <div class="toggle-state state-on">ON</div>
  <div class="toggle-state state-off">OFF</div>
</div>
